import CategoryController from "./category-controller";
import SubcategoryController from "./subcategory-controller";
import SearchController from "./search-controller";

export default class CoursesMenu {
	constructor($root, {
		defaultScreenId = 'sprints'
	} = {}) {
		this.$root = $root;
		this.$searchField = null;
		this.$categoriesMenu = null;
		this.$searchPanel = null;

		this.defaultScreenId = defaultScreenId;
		this.activeScreenId = defaultScreenId;
		this.initialSubcategory = null;

		this.searchController = null;
		this.categoryController = null;
		this.subcategoryControllers = [];

		this.initialized = false;
	}

	init() {
		if (!this.$root) {
			throw new Error('Courses Menu: Root element is missing');
		}

		if (this.initialized) {
			return;
		}

		this.defineViews();
		this.addComponents();
		this.addEventListeners();
		this.setInitialState();

		this.initialized = true;
	}

	defineViews() {
		this.$searchField = document.getElementById('coursesMenuSearchField');
		this.$categoriesMenu = document.getElementById('coursesMenuControlPanel');
		this.$searchPanel = document.getElementById('coursesMenuSearchPanel');
	}

	addComponents() {
		this.searchController = new SearchController(this.$searchField, this.$searchPanel);
		this.categoryController = new CategoryController(this.$categoriesMenu);
	}

	addEventListeners() {
		this.addFocusSearchInputListener();
		this.addChangeCategoryListener();
	}

	setInitialState() {
		this.getActiveScreen();
		this.categoryController.dispatchEvent('changeCategory', this.activeScreenId);
		this.$root.classList.add(`-${this.activeScreenId}`);
	}

	addFocusSearchInputListener() {
		this.searchController.subscribe('focusSearchInput', (e) => {
			this.activateSearchPanel();
		});
	}

	addChangeCategoryListener() {
		this.categoryController.subscribe('changeCategory', (e) => {
			this.deactivateSearchPanel();
			this.setActiveScreen(e.detail);
		});
	}

	getActiveScreen() {
		let $screen = this.$root.querySelector(`.courses-nav-screen[data-id="${this.activeScreenId}"]`);

		if (!$screen) {
			this.activeScreenId = 'sprints';
			$screen = this.$root.querySelector(`.courses-nav-screen[data-id="${this.activeScreenId}"]`);

			if (!$screen) {
				$screen = this.$root.querySelector(`.courses-nav-screen`);
				this.activeScreenId = $screen.dataset.id;
			}
		}

		return $screen;
	}

	setActiveScreen(id) {
		this.activeScreenId = id;
		this.refreshActiveScreen();
	}

	activateSearchPanel() {
		this.dropActiveScreenClass();
		this.categoryController.dropActiveCategoryControl();
		this.$searchPanel.classList.add('-active');
		this.$root.classList.add('-search');
	}

	deactivateSearchPanel() {
		this.$searchPanel.classList.remove('-active');
		this.$root.classList.remove('-search');
	}

	refreshActiveScreen() {
		this.$activeScreen = this.getActiveScreen();

		if (!this.$activeScreen) {
			return;
		}

		this.dropActiveScreenClass();
		this.$activeScreen.classList.add('-active');

		const $subcatsControlPanel = this.$activeScreen.querySelector('.subcats-nav');

		if ($subcatsControlPanel) {
			this.initSubcategoryController($subcatsControlPanel);
		}
	}

	dropActiveScreenClass() {
		const $screen = this.$root.querySelector('.courses-nav-screen.-active');

		if (!$screen) return;

		$screen.classList.remove('-active');
	}

	initSubcategoryController($subcatsControlPanel) {
		const currentSubcatController = this.subcategoryControllers
			.findIndex((controller) => (controller.id === this.activeScreenId));
		const exists = currentSubcatController !== -1;

		if (exists) return;

		this.subcategoryControllers.push(new SubcategoryController(
			$subcatsControlPanel,
			this.activeScreenId,
			{
				subcategoryId: this.initialSubcategory,
				onChangeSubcategory: (e) => {
					this.handleSubcategoryChange(e.detail);
				}
			}
		));
	}

	handleSubcategoryChange(subcatId) {
		this.setActiveCoursesNav(subcatId);
	}

	setActiveCoursesNav(id) {
		const $activeScreen = this.getActiveScreen();
		const $currentActiveNav = $activeScreen.querySelector('.courses-nav-list.-active');

		if ($currentActiveNav) {
			$currentActiveNav.classList.remove('-active');
		}

		let $newActiveNav = $activeScreen.querySelector(`[data-id=${id}]`);

		if (!$newActiveNav) {
			throw new Error('Courses Menu Error: There is no courses nav with such id');
		}

		$newActiveNav.classList.add('-active');
	}
}